
import { useState } from 'react';

export default function CompromissoPratica() {
  const [nome, setNome] = useState('');
  const [dias, setDias] = useState(21);
  const [assinado, setAssinado] = useState(false);
  const [checkDays, setCheckDays] = useState<number[]>([]);

  const toggleDay = (day: number) => {
    setCheckDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const completedDays = checkDays.length;
  const progressPercent = Math.round((completedDays / dias) * 100);

  return (
    <section className="py-24 bg-white print:py-8">
      <div className="max-w-5xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14 print:mb-8">
          <div className="flex items-center justify-center gap-4 mb-5 print:hidden">
            <div className="w-12 h-px bg-[#D4AF37]/40"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-[#D4AF37]">
              Compromisso Pessoal
            </span>
            <div className="w-12 h-px bg-[#D4AF37]/40"></div>
          </div>
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-5">
            Seu Compromisso de <span className="text-[#D4AF37] italic">Prática</span>
          </h2>
          <p className="font-['Montserrat'] text-base text-[#6A6A6A] max-w-2xl mx-auto leading-relaxed">
            A neurociência comprova: são necessários pelo menos 21 dias de prática
            consistente para criar novos padrões neurais. Assine seu compromisso.
          </p>
        </div>

        {/* Compromisso Card */}
        <div className="bg-gradient-to-br from-[#1A1A1A] to-[#2A2A2A] rounded-3xl p-10 md:p-14 text-center mb-12 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent"></div>
          <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent"></div>
          <div className="absolute top-10 right-10 w-40 h-40 bg-[#D4AF37]/5 rounded-full blur-[80px]"></div>

          <div className="relative z-10">
            <i className="ri-quill-pen-line text-5xl text-[#D4AF37] mb-6 block"></i>

            <h3 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-white mb-8 leading-relaxed">
              &ldquo;Eu, <span className="border-b-2 border-dashed border-[#D4AF37]/50 inline-block min-w-[200px]">
                <input
                  type="text"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="seu nome"
                  className="bg-transparent text-[#D4AF37] font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-center w-full focus:outline-none placeholder:text-[#D4AF37]/30"
                />
              </span>, me comprometo a praticar minhas Encantations todos os dias pelos próximos{' '}
              <span className="text-[#D4AF37]">{dias} dias</span>, com intensidade total, movimento e emoção.&rdquo;
            </h3>

            {/* Seletor de Dias */}
            <div className="flex items-center justify-center gap-3 mb-8 print:hidden">
              {[7, 14, 21, 30, 60, 90].map((d) => (
                <button
                  key={d}
                  onClick={() => setDias(d)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                    dias === d
                      ? 'bg-[#D4AF37] text-black'
                      : 'bg-white/5 text-white/60 border border-white/10 hover:border-[#D4AF37]/30'
                  }`}
                >
                  {d} dias
                </button>
              ))}
            </div>

            {/* Botão Assinar */}
            <button
              onClick={() => setAssinado(!assinado)}
              className={`px-10 py-4 rounded-xl font-['Montserrat'] font-bold text-base transition-all cursor-pointer whitespace-nowrap ${
                assinado
                  ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/20'
                  : 'bg-[#D4AF37] text-black hover:bg-[#C5A028] shadow-lg shadow-[#D4AF37]/20'
              }`}
            >
              {assinado ? (
                <>
                  <i className="ri-check-double-line mr-2"></i>
                  Compromisso Assinado!
                </>
              ) : (
                <>
                  <i className="ri-quill-pen-line mr-2"></i>
                  Assinar Meu Compromisso
                </>
              )}
            </button>

            {assinado && nome && (
              <p className="font-['Montserrat'] text-sm text-white/50 mt-4">
                Assinado por <strong className="text-[#D4AF37]">{nome}</strong> em{' '}
                {new Date().toLocaleDateString('pt-BR', {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric',
                })}
              </p>
            )}
          </div>
        </div>

        {/* Rastreamento de 21 Dias */}
        <div className="bg-[#FAF8F5] rounded-2xl p-8 md:p-10 border border-[#D4AF37]/10">
          <div className="flex items-center justify-between mb-6">
            <h3 className="font-['Playfair_Display'] text-2xl font-bold text-[#1A1A1A]">
              <i className="ri-calendar-check-line text-[#D4AF37] mr-2"></i>
              Rastreamento de Prática
            </h3>
            <div className="flex items-center gap-2">
              <span className="font-['Montserrat'] text-sm text-[#6A6A6A]">
                {completedDays}/{dias} dias
              </span>
              <span className="font-['Montserrat'] text-sm font-bold text-[#D4AF37]">
                {progressPercent}%
              </span>
            </div>
          </div>

          {/* Progress */}
          <div className="w-full h-3 bg-[#D4AF37]/10 rounded-full overflow-hidden mb-8">
            <div
              className="h-full bg-gradient-to-r from-[#D4AF37] to-emerald-500 rounded-full transition-all duration-500"
              style={{ width: `${progressPercent}%` }}
            ></div>
          </div>

          {/* Calendar Grid */}
          <div className="grid grid-cols-7 gap-2">
            {Array.from({ length: dias }, (_, i) => i + 1).map((day) => {
              const isChecked = checkDays.includes(day);
              return (
                <button
                  key={day}
                  onClick={() => toggleDay(day)}
                  className={`aspect-square rounded-xl flex flex-col items-center justify-center text-sm font-medium transition-all cursor-pointer ${
                    isChecked
                      ? 'bg-gradient-to-br from-[#D4AF37] to-[#B8941E] text-black shadow-sm'
                      : 'bg-white text-[#6A6A6A] border border-[#D4AF37]/10 hover:border-[#D4AF37]/30'
                  }`}
                >
                  {isChecked ? (
                    <i className="ri-check-line text-lg"></i>
                  ) : (
                    <span>{day}</span>
                  )}
                </button>
              );
            })}
          </div>

          {/* Legenda */}
          <div className="flex items-center justify-center gap-6 mt-6">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded bg-gradient-to-br from-[#D4AF37] to-[#B8941E]"></div>
              <span className="font-['Montserrat'] text-xs text-[#6A6A6A]">Dia praticado</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded bg-white border border-[#D4AF37]/10"></div>
              <span className="font-['Montserrat'] text-xs text-[#6A6A6A]">Pendente</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
